Controller = App.loadClass 'core::Angular/Controller'

class exports.FarmFieldController extends Controller

    constructor: (@scope, @transitions, @repo, @modal) ->
        super(@scope, @transitions)

        # this will be set as you iterate between fields
        @scope.step.title = 'Farm - Field'
        @scope.step.next = @next
        @scope.step.previous = @previous
        @scope.step.includeDuplicates = @includeDuplicates
        @scope.step.canContinue = @canContinue

        # stuff for survey results
        @scope.placeholder = 'No surveys to display'
        @scope.survey_results = []
        @scope.showSurveyFields = @showSurveyFields
        @scope.viewDetails = @viewDetails
        @scope.viewPlan = @viewPlan
        @scope.toggleSurveyResult = @toggleSurveyResult
        @scope.isSurveyResultSelected = @isSurveyResultSelected
        @scope.numPlans = (sr) => Object.keys(sr.planned_fields).length

        # start with the first year for the first field
        first_field = @scope.selected.duplicate_fields[0]
        @setFieldYear(first_field, first_field.years[0])

    setFieldYear: (field, year) =>
        @scope.current_field = field
        @scope.current_year = year

        @scope.step.title = "#{field.farm_name} - #{field.name}"
        @loadSurveyResults()

    loadSurveyResults: () =>
        @scope.survey_results = []
        for survey_result in @scope.selected.survey_results
            if survey_result.year is @scope.current_year and
                    survey_result.planned_fields[@scope.current_field.id]?
                @scope.survey_results.push survey_result

        @sanityCheck()

    sanityCheck: () =>
        # this is just to make absolutely sure we don't have bad values
        # selected that aren't actually options (reverse for loop because we're
        # deleting things)
        for survey_result in @scope.current_field.survey_results[@scope.current_year] by -1
            if _.findIndex(@scope.survey_results, { id: survey_result.id }) is -1
                @toggleSurveyResult(survey_result)

    isFirstFieldYear: () =>
        first_field = @scope.selected.duplicate_fields[0]
        return (@scope.current_field is first_field and
                @scope.current_year is first_field.years[0])

    loadPreviousFieldYear: () =>
        # srsly. this is some complicated shiiiiiiindizzle.
        year_index = @scope.current_field.years.indexOf(@scope.current_year)
        if year_index > 0
            # just change to the previous year
            prev_year = @scope.current_field.years[year_index - 1]
            @setFieldYear(@scope.current_field, prev_year)
        else
            # change to the last year for the previous field
            field_index = _.findIndex(@scope.selected.duplicate_fields, { id: @scope.current_field.id })
            if field_index > 0
                prev_field = @scope.selected.duplicate_fields[field_index - 1]
                @setFieldYear(prev_field, _.last(prev_field.years))
            else
                # something went wrong. just go back to the first one, I guess?
                first_field = @scope.selected.duplicate_fields[0]
                @setFieldYear(first_field, first_field.years[0])

    previous: () =>
        @scope.$parent.clearAlert()
        if @isFirstFieldYear()
            @scope.goToStep('duplicate_fields')
        else
            @loadPreviousFieldYear()

    isLastFieldYear: () =>
        last_field = _.last(@scope.selected.duplicate_fields)
        return (@scope.current_field is last_field and
                @scope.current_year is _.last(last_field.years))

    loadNextFieldYear: () =>
        year_index = @scope.current_field.years.indexOf(@scope.current_year)
        if year_index < (@scope.current_field.years.length - 1)
            # just change to the next year
            next_year = @scope.current_field.years[year_index + 1]
            @setFieldYear(@scope.current_field, next_year)
        else
            # change to the first year for the next field
            field_index = _.findIndex(@scope.selected.duplicate_fields, { id: @scope.current_field.id })
            if field_index < (@scope.selected.duplicate_fields.length - 1)
                next_field = @scope.selected.duplicate_fields[field_index + 1]
                @setFieldYear(next_field, next_field.years[0])
            else
                # something went wrong. just go back to the first one, I guess?
                first_field = @scope.selected.duplicate_fields[0]
                @setFieldYear(first_field, first_field.years[0])

    next: () =>
        @scope.$parent.clearAlert()
        if @isLastFieldYear()
            # final check for duplicates
            if @hasRemainingDuplicates()
                @scope.goToStep('download')
            else
                @repo.launchPsr(@scope.selected, @scope.step)
        else
            @loadNextFieldYear()

    includeDuplicates: () =>
        # just select all and then call next()
        for survey_result in @scope.survey_results
            if not @isSurveyResultSelected(survey_result)
                @toggleSurveyResult(survey_result)
        @next()

    canContinue: () =>
        return @scope.current_field?.survey_results[@scope.current_year].length > 0

    showSurveyFields: (survey_result) =>
         # launch the dialog
        modal_instance = @modal.open
            windowClass: 'small_dialog'
            templateUrl: 'backend/grower/placement/survey-fields-dialog'
            controller: 'Placement.Controllers.SurveyFieldsDialogController'
            scope: @scope
            resolve:
                'survey_result': -> survey_result

    viewDetails: (survey_result, field) =>
        modal_instance = @modal.open
            windowClass: 'large_dialog'
            templateUrl: 'backend/grower/placement/report/survey-details-dialog'
            controller: 'Placement.Controllers.SurveyDetailsDialogController'
            scope: @scope
            resolve:
                'survey_result': -> survey_result
                'field': -> field

    viewPlan: (survey_result, field) =>
        modal_instance = @modal.open
            windowClass: 'dialog_500'
            templateUrl: 'backend/grower/placement/report/plan-details-dialog'
            controller: 'Placement.Controllers.PlanDetailsDialogController'
            scope: @scope
            resolve:
                'survey_result': -> survey_result
                'field': -> field

    toggleSurveyResult: (survey_result) =>
        i = _.findIndex(@scope.current_field.survey_results[@scope.current_year], { id: survey_result.id })
        if i is -1
            # survey result is not selected. add it to the array
            @scope.current_field.survey_results[@scope.current_year].push(survey_result)
        else
            # survey result is selected. remove it from the array
            @scope.current_field.survey_results[@scope.current_year].splice(i, 1)

    isSurveyResultSelected: (survey_result) =>
        return _.findIndex(@scope.current_field.survey_results[@scope.current_year], { id: survey_result.id }) > -1

    hasRemainingDuplicates: () =>
        for field in @scope.selected.duplicate_fields
            for year, survey_results of field.survey_results
                if survey_results.length isnt 1
                    return true
        return false
